import { Box, Grid, Menu, MenuItem, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import { Map } from "schemas/functions";

import { Option, Subgroup } from "./schema";

interface SubgroupMenuItemProps {
  subgroup: Subgroup;
  options: Option[];
  params: string;
  iconsMap?: Map;
  isOptionSelected: (key: string, params: string) => boolean;
  selectedOptionIcon: JSX.Element;
  onSelect: (params: string, key: string, paidOnly?: boolean) => void;
  getIcon: (key: string, isLock: boolean) => React.ReactNode;
  subscription: { isSubscribed?: boolean } | null | undefined;
}

const SubgroupMenuItem = ({
  subgroup,
  options,
  params,
  isOptionSelected,
  selectedOptionIcon,
  onSelect,
  getIcon,
  subscription,
}: SubgroupMenuItemProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleOpen = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(e.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  const hasSelected = options.some((o) => isOptionSelected(o.key, params));

  return (
    <>
      <MenuItem dense onClick={handleOpen}>
        <Tooltip title="" placement="right">
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item sx={{ display: "flex", alignItems: "center" }}>
              {hasSelected && selectedOptionIcon}
              {subgroup.icon && (
                <Box sx={{ mr: 1, display: "flex", alignItems: "center" }}>
                  {subgroup.icon}
                </Box>
              )}
              <Typography>{subgroup.label}</Typography>
            </Grid>
            <Box
              component="i"
              className="fa-regular fa-chevron-right"
              sx={{ ml: 2, fontSize: 11, color: "text.secondary" }}
            />
          </Grid>
        </Tooltip>
      </MenuItem>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        {options.map((option) => (
          <MenuItem
            dense
            key={option.key}
            onClick={() => {
              onSelect(params, option.key, option.paidOnly);
              handleClose();
            }}
          >
            <Tooltip title={option.label} placement="right">
              <Grid container alignItems="center">
                {isOptionSelected(option.key, params) && selectedOptionIcon}
                <Box sx={{ mr: 1 }}>
                  {getIcon(
                    option.key,
                    Boolean(option.paidOnly && !subscription?.isSubscribed),
                  )}
                </Box>
                <Typography>{option.name}</Typography>
              </Grid>
            </Tooltip>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default SubgroupMenuItem;
